import ILocationSearchType from '../interfaces/ilocation-search-type';

export default {
    // VM
    getHasError: (state: any) => state.HasError,
    getIsLoading: (state: any) => state.IsLoading,
    getCheckedLocationSearchTypes: (state: any) => state.LocationSearchTypes.filter((lst: ILocationSearchType) => lst.Checked),
    getAllLocationSearchTypes: (state: any) => state.LocationSearchTypes,
    getCheckedLocationSearchTypeValues: (state: any) => state.LocationSearchTypes.filter((lst: ILocationSearchType) => lst.Checked).map((lst: ILocationSearchType) => lst.LocationTypeValue),
    getAllLocations: (state: any) => state.Locations,
    getSelectedLocation: (state: any) => state.SelectedLocation,
    getSelectedIndex: (state: any) => state.SelectedIndex,
    getFocusedIndex: (state: any) => state.FocusedIndex,
    // Maps
    getShowMyLocation: (state: any) => state.ShowMyLocation,
    getLocationMarkers: (state: any) => state.LocationMarkers,
    // Paging
    getCurrentPageNumber: (state: any) => state.CurrentPageNumber,
    getTotalSearchResults: (state: any) => state.TotalSearchResults,
    getTotalPages: (state: any) => state.TotalPages,
    getAnyTotalPages: (state: any) => state.TotalPages > 0,
    // Filtering
    getShowFilterButton: (state: any) => state.ShowFilterButton,
    // Searching
    getIsSearching: (state: any) => state.IsSearching,
    getHasSearched: (state: any) => state.HasSearched,
    getShowSearchHistory: (state: any) => state.ShowSearchHistory,
    getSearchText: (state: any) => state.SearchText,
    getSearchHistory: (state: any) => state.SearchHistory,
    getSearchHistoryCoords: (state: any) => state.SearchHistoryCoords,
    // Mobile
    getEmblaScrollToIndex: (state: any) => state.EmblaScrollToIndex,
    getUsedMyLocation: (state: any) => state.UsedMyLocation,
    getWidgetTitle: (state: any) => state.WidgetTitle,
    getCurrentUser: (state: any) => state.UserID
};